import React from "react";
import "../../styles/Admin.css";

const AdminTable = ({ columns, data, actions, loading, emptyMessage = "No data available" }) => {
  if (loading) {
    return (
      <div className="admin-table-wrapper">
        <div className="admin-loading">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="admin-table-wrapper">
        <div className="admin-empty-state">
          <p className="admin-empty-state-description">{emptyMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-table-wrapper">
      <table className="admin-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key} style={col.align ? { textAlign: col.align } : {}}>
                {col.label}
              </th>
            ))}
            {actions && <th style={{ width: "120px", textAlign: "right" }}>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={row.id || idx}>
              {columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
              {actions && (
                <td>
                  <div className="admin-actions">
                    {actions(row)}
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminTable;

